export default __webpack_public_path__ + "logo-eaep-47871375ad8cac7d5eb9c41150507055.svg";